<template>
  <b-card no-body>
    <b-card-header class="pb-50">
      <h5>
        Periode Ujian
      </h5>
    </b-card-header>
    <b-card-body>
      <b-row>
        <b-col md="4">
          <b-form-group
            label="Mulai Tanggal"
            label-for="mulai_tanggal"
          >
            <b-form-datepicker v-model="filter.dari" locale="id"></b-form-datepicker>
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group
            label="Sampai Tanggal"
            label-for="sampai_tanggal"
          >
            <b-form-datepicker v-model="filter.sampai" locale="id"></b-form-datepicker>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2 mt-2"
        >
          <b-button variant="primary" @click="download()">Update</b-button>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BRow, BCol, BFormInput, BButton, BFormDatepicker, BFormGroup
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {
  getJenisSidang,
  getStatusPengajuanSidang,
  updatePeriodeUjian,
  getPeriodeUjian,
} from '@/connection-api/master'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect,
    BFormInput,
    BButton,
    BFormDatepicker,
    BFormGroup,
  },
  data() {
    return {
      filter: {},
      count: 0,
      jenisSidangOption: {
        selected: 'id',
        options: [
          { value: null, label: '--Pilih Jenis Sidang --' },
        ],
      },
      statusPengajuanOption: {
        selected: 'id',
        options: [
          { value: null, label: '--Pilih Status Pengajuan Sidang --' },
        ],
      },
    }
  },
  props: {
    triggerFilter: {
      default: null,
    },
    dataFilter: {
      default: null,
    },
  },
  beforeCreate() {
      getPeriodeUjian()
      .then(response => {
        if(response.data.success){
          this.filter = response.data.data
        }
      })
      .catch(error => console.log(error));
  },
  methods: {
    async download()
    {
      this.showLoader = true
      const response = await updatePeriodeUjian(this.filter)
      if(response.data.success === true){
          this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Periode Ujian',
                icon: 'CoffeeIcon',
                variant: 'success',
                text: 'Data berhasil di update',
              },
            })
        }else{
          this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Periode Ujian',
                icon: 'CoffeeIcon',
                variant: 'danger',
                text: 'Data gagal di update',
              },
            })
        }
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
